import * as React from 'react';
export const vanbredaSvg = React.forwardRef(function vanbredaSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1A3C7A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M32 31.999H0V25.5L32 16v15.999Z',
      fill: '#777F80',
    }),
  );
});
vanbredaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vanbreda = {
  category: 'brand',
  colorable: false,
  name: 'vanbreda',
  svg: vanbredaSvg,
};
